export default "__VITE_ASSET__eVAjGQNh__"